<template>
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog" :id="`payment-details-${id}`" :aria-labelledby="`payment-details-${id}-label`" aria-hidden="false">
        <div class="modal-dialog payment-details-modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header new-design">
                    <h5 class="modal-title d-inline">
                        Payment
                        <span :class="{'status-label labels-font font-family-Roboto position-status':true,[statusLabelColorClass]:statusLabelColorClass}">
                           {{ statusLabel}}
                        </span>
                    </h5>
                    <svg class="close-icon clickable" width="14"
                         height="14" @click.stop="closeModal" data-dismiss="modal" aria-label="Close"
                         viewBox="0 0 14 14" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                            fill="#03A9F4"/>
                    </svg>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-4 p-right-0 p-left-0">
                            <div class="col-md-12 labels-font font-family-Roboto">Date</div>
                            <div class="col-md-12">
                                {{ paymentDetail.received_formatted_date }}
                            </div>
                        </div>

                        <div class="col-md-4 p-right-0 p-left-0">
                            <div class="col-md-12 labels-font font-family-Roboto">Reference</div>
                            <div class="col-md-12">
                              {{ paymentDetail.reference }}
                            </div>
                        </div>

                      <div class="col-md-4 p-right-0 p-left-0">
                        <div class="col-md-12 labels-font font-family-Roboto">Payment method</div>
                        <div class="col-md-12">
                          {{ paymentDetail.payment_type }}
                        </div>
                      </div>
                    </div>

                    <hr/>

                    <div class="row">
                        <div class="col-md-4 p-right-0 p-left-0">
                            <div class="col-md-12 labels-font font-family-Roboto">Added by</div>
                            <div class="col-md-12">
                                {{ paymentDetail.customer_name ?? paymentDetail.username }} ({{paymentDetail.customer_name ? 'customer':paymentDetail.user_role}})
                            </div>
                        </div>
                      <div class="col-md-4 p-right-0 p-left-0">
                            <div class="col-md-12 labels-font font-family-Roboto">{{ bookingInvoice.company_fieldworker_label }}</div>
                            <div class="col-md-12">
                                {{ paymentDetail.fieldworker_name }}
                            </div>
                        </div>


                        <div class="col-md-4 p-right-0 p-left-0" v-if="paymentDetail.insert_type">
                            <div class="col-md-12 labels-font font-family-Roboto">Insert type</div>
                            <div class="col-md-12">
                              {{ paymentDetail?.insert_type_method }}
                              <span v-if="paymentDetail?.insert_type_ver">
                                - Ver.{{ paymentDetail?.insert_type_ver }}
                              </span>
                              <span v-if="paymentDetail?.insert_type_os">
                                - OS {{ paymentDetail?.insert_type_os }}
                              </span>

                            </div>
                        </div>
                        <div class="col-md-4 p-right-0 p-left-0" v-if="paymentDetail.refund_reason">
                            <div class="col-md-12 labels-font font-family-Roboto">Refund reason</div>
                            <div class="col-md-12">
                              {{ paymentDetail.refund_reason }}
                            </div>
                        </div>
                    </div>

                    <div class="row gray-div m-top-20" v-if="paymentDetail.amount">
                        <div class="col-md-12 col-xs-12 p-right-0 p-left-0">
                            <div class="col-md-10 col-xs-6 labels-font font-family-Roboto">Amount</div>
                            <div class="col-md-2 col-xs-6">
                               <span class="float-right"> {{ currency.currency_symbol }}{{ paymentDetail.amount }} </span>
                            </div>
                        </div>
                        <div class="col-md-12 col-xs-12 p-right-0 p-left-0" v-if="paymentDetail.tip">
                            <div class="col-md-10 col-xs-6 labels-font font-family-Roboto">Tip</div>
                            <div class="col-md-2 col-xs-6">
                                <span class="float-right"> {{ currency.currency_symbol }}{{ paymentDetail.tip }} </span>
                            </div>
                        </div>
                        <div class="col-md-12 col-xs-12  p-right-0 p-left-0" v-if="paymentDetail.surcharge">
                            <div class="col-md-10 col-xs-6 labels-font font-family-Roboto">Surcharge</div>
                            <div class="col-md-2 col-xs-6">
                                <span class="float-right"> {{ currency.currency_symbol }}{{ paymentDetail.surcharge }} </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer new-design">
                    <div class="col-md-12" v-if="paymentDetail.type === 'payment'">
                      <!--  Payment   -->
                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width" :href="`/payment/edit/${paymentDetail.id}/${bookingInvoice.id}?merged_invoice_id=${paymentDetail.merged_invoice_id}`" v-if="!paymentDetail.is_pre_auth && !paymentDetail.is_approved && bookingInvoice.credentials.paymentEdit && paymentDetail.payment_type_flag !== 'credit_card'">Edit</a>
                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width" href="javascript:void(0)" data-toggle="modal" data-target="#popupi"  v-if="paymentDetail.is_approved && paymentDetail.payment_type_flag === 'credit_card'" @click="refundPayment(bookingInvoice.booking_id, paymentDetail.id)">Refund payment</a>
                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width" v-if=" paymentDetail.payment_type_flag === 'other' && paymentDetail.is_approved" :href="`/refund/add/${bookingInvoice.booking_id}?merged_invoice_id=${paymentDetail.merged_invoice_id}`">Add Refund</a>
                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width" title="Reject" href="#" data-toggle="modal" data-target="#popupi" v-if="!paymentDetail.is_approved && !paymentDetail.is_rejected  && !paymentDetail.is_pre_auth && paymentDetail.payment_type_flag !== 'credit_card'" @click="declinePayment(paymentDetail.id,bookingInvoice.id)">Decline</a>
                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width" title="Accept Pre-auth" v-if="paymentDetail.is_pre_auth && !paymentDetail.pre_auth_status"
                         @click="acceptOrDeclinePreAuthPayment(paymentDetail.booking_id,paymentDetail.id , 1)">Authorize Capture</a>

                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width" title="Cancel Pre-auth" v-if="paymentDetail.is_pre_auth && !paymentDetail.pre_auth_status" @click="acceptOrDeclinePreAuthPayment(paymentDetail.booking_id,paymentDetail.id , 0)">Revoke Authorization</a>
                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width" v-if="!paymentDetail.is_approved" href="#" data-target="#popupi" data-toggle="modal" @click="changeInvoiceNumber(paymentDetail.id)"> Edit assigned invoice</a>
                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width"  href="javascript:void(0)" v-if="!paymentDetail.is_rejected  && !paymentDetail.is_pre_auth && !paymentDetail.is_approved && bookingInvoice.credentials.paymentApprove && paymentDetail.payment_type_flag !== 'credit_card'"  @click="approveCurrentPayment(this,paymentDetail.id, bookingInvoice.id,bookingInvoice.booking_id,bookingInvoice.merged_invoice_id,id)">Approve</a>
                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width"  href="javascript:void(0)" v-if="!paymentDetail.is_rejected  && !paymentDetail.is_pre_auth && paymentDetail.is_approved && bookingInvoice.credentials.paymentUnapprove && !paymentDetail.is_pre_auth && paymentDetail.payment_type_flag !== 'credit_card'"  @click="unApproveCurrentPayment(this,paymentDetail.id, bookingInvoice.id,bookingInvoice.booking_id,bookingInvoice.merged_invoice_id,id)">Unapprove </a>

                      <a
                        v-if=" canSeeCustomer || loggedUser?.role_id != 1"
                        type="button"
                        class="btn btn-primary new-design float-left btn-mobile-width"
                        href="javascript:void(0)"
                        title="Payment Receipt"
                        data-toggle="modal" data-target="#popupi"
                        @click="emailRecpipt('payment')" > Email receipt
                      </a>

                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width" v-if="!paymentDetail.is_pre_auth && !paymentDetail.is_approved && paymentDetail.payment_type_flag !== 'credit_card'" @click="deletePayment(paymentDetail.booking_id,paymentDetail.id,id)">Delete</a>
                    </div>
                    <div class="col-md-12" v-else-if="paymentDetail.type ==='refund'">
                      <!--  refund   -->
                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width"
                         :href="`/refund/edit/${paymentDetail.id}/${bookingInvoice.id}?merged_invoice_id=${paymentDetail.merged_invoice_id}&id=${paymentDetail.id}&booking_id=${paymentDetail.booking_id}`"
                         v-if=" bookingInvoice && !paymentDetail.is_approved && paymentDetail.payment_type_flag !== 'credit_card'">Edit</a>

                        <a type="button" class="btn btn-primary new-design float-left btn-mobile-width"    v-if="!paymentDetail.is_rejected && !paymentDetail.is_approved"
                         @click="approve_refund(paymentDetail.booking_id,paymentDetail.id,paymentDetail.merged_invoice_id) "   >Approve refund</a>
                      <a type="button" class="btn btn-primary new-design float-left btn-mobile-width"     v-if="!paymentDetail.is_rejected   && paymentDetail.is_approved && paymentDetail.payment_type_flag !== 'credit_card'"
                         @click="Unapprove_refund(paymentDetail.booking_id,paymentDetail.id,paymentDetail.merged_invoice_id) "  >Unapprove refund</a>
                        <a type="button" class="btn btn-primary new-design float-left btn-mobile-width" href="javascript:void(0)" title="Payment Receipt" data-toggle="modal" data-target="#popupi"  v-if="paymentDetail.is_approved && (canSeeCustomer || loggedUser?.role_id != 1)" @click="emailRecpipt('refund',paymentDetail.id)" >Email receipt</a>

                        <a type="button" class="btn btn-primary new-design float-left btn-mobile-width"  v-if="!paymentDetail.is_approved" @click="deleteRefund(paymentDetail.booking_id,paymentDetail.id,id)">Delete</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";

export default {
  name: "PaymentDetailsModal",
  props: {
      id: {
          required: true
      },
      statusLabelColorClass: null,
      loggedUser: null,
      canSeeCustomer:null,
      calculatePricesMethod:Function,
      getPaymentsMethod:Function,
      isVisible: Boolean,
      statusLabel: null,
      paymentDetail: {
          required: true
      },
      bookingInvoice: {
          required: true
      },
      currency: {
          required: true
      },
  },
  data() {
    return {}
  },

  methods: {
    changeInvoiceNumber(payment_id = 0) {
      // invoice/change-invoice/
      window.popupi('Edit Assigned Invoice', `/invoice/change-invoice/${payment_id}`)
    },
      closeModal() {
        $(this.$refs['modal']).modal('hide');
          // this.$emit('close-modal');
      },
    refundPayment(booking_id = 0, payment_id = 0) {
      window.popupi("Refund Payment", `/refund/addrefund/${booking_id}/${payment_id}`)
    },
    declinePayment(payment_id = 0, invoice_id = 0) {
      window.popupi("Invoice Discussion", `/invoice/discussion/${invoice_id}/${payment_id}`)
        $("#popupi #modal_title").html("Invoice Discussion");
    },
    acceptOrDeclinePreAuthPayment(booking_id = 0, payment_id = 0, type)
    {
      let redirectLink = `/pre-auth-payment/approve/${booking_id}/${payment_id}`;
      let $div = $('<div id="acceptDeclinePayment" class="modal fade"><div class="modal-dialog"><div class="modal-content"> <div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title">Confirmation Message</h4></div><div class="modal-body"> <p>Are you sure you want to continue?</p> </div><div class="modal-footer"><a type="button" class="btn btn-primary" id="okBtn">YES</a><a type="button" class="btn btn-default" data-dismiss="modal">NO</a></div></div></div></div>').appendTo('body');
      if (type == 1) {
        $("#acceptDeclinePayment .modal-title").html('Authorize Capture');
        $("#acceptDeclinePayment .modal-body").html('Are you sure you want to Authorize Capture? This will secure the pre-authorized payment. This action cannot be undone.');
      } else {
        $("#acceptDeclinePayment .modal-title").html('Revoke Authorization');
        $("#acceptDeclinePayment .modal-body").html('Are you sure you want to Revoke Authorization? This will cancel the pre-authorized payment. This action cannot be undone.');
      }
      $('#acceptDeclinePayment').modal('show');
      $('#acceptDeclinePayment .modal-footer').show();

let vm = this;
      $('body').on('click', '#acceptDeclinePayment #okBtn', function () {
          let formDataInputs = new FormData();
          formDataInputs.append('is_ajax', 1);
          axios.post(redirectLink,formDataInputs).then(function (response) {
              if (response.data.type === 'success') {
                  $.notify(response.data.msg, 'success');
                  vm.getPaymentsMethod()
              }else{
                  $.notify(response.data.msg, 'error');
              }
              return
          });
      });
    },
    deletePayment(booking_id = 0, payment_id = 0,id) {
      let url = `/payment/delete?booking_id=${booking_id}&id=${payment_id}`;
      /**
       *  Updated BY KAREEM
       *  data of the confirm popup ( it will show in the popup )
       *  our new confirm popup
       * */
      var data = {
        title: 'Confirm delete',
        message: 'Are you sure you want to delete this payment?',
        confirm: 'Delete',
        cancel: 'Cancel'
      };
let vm = this ;
      confirm_popup(data, function () {
          axios.post(url).then(function (response) {
              if (response.data.type === 'success') {
                  $(`#payment-details-${id}`).modal('hide');
                  $.notify(response.data.msg, 'success');
                  vm.$emit('delete');
              }else{
                  $.notify(response.data.msg, 'error');
              }
              return
          });
      }, function () {
        });
    },
    deleteRefund(booking_id = 0, payment_id = 0,id) {
      let url = `/refund/delete/${this.paymentDetail.booking_id}/${this.paymentDetail.id}/${this.paymentDetail.merged_invoice_id}?ajax=1`;
      /**
       *  Updated BY KAREEM
       *  data of the confirm popup ( it will show in the popup )
       *  our new confirm popup
       * */
      var data = {
        title: 'Confirm delete',
        message: 'are you sure you want to delete this Refund?',
        confirm: 'Delete',
        cancel: 'Cancel'
      };
let vm = this ;
      confirm_popup(data, function () {
          axios.post(url).then(function (response) {
              if (response.data.type === 'success') {
                  $(`#payment-details-${id}`).modal('hide');
                  $.notify(response.data.msg, 'success');
                  vm.$emit('delete');
              }else{
                  $.notify(response.data.msg, 'error');
              }
              return
          });
      }, function () {
      });
    },
    emailRecpipt($paymentOrRefund,$refund_id =0){

        if (this.bookingInvoice.customer_id  && this.bookingInvoice.group_customer_id ){
           var customer_id_data= this.bookingInvoice.group_customer_id
        }else {
            var customer_id_data= this.bookingInvoice.customer_id

        }
        if($paymentOrRefund=='refund'){
            window.popupi(`Email Receipt`, `/get-canned-responses-form/customer/email/refund/${$refund_id}/${customer_id_data}/${$paymentOrRefund}_acknowledgment`);
        }else{
            window.popupi(`Email Receipt`, `/get-canned-responses-form/customer/email/invoice/${this.bookingInvoice.id}/${customer_id_data}/${$paymentOrRefund}_acknowledgment`);

        }
    },

    approveCurrentPayment(object, payment_id = 0, invoice_id = 0,booking_id = 0, merged_invoice_id = 0, index = 0) {
        let approvePaymentURL = `/payment/approve/${booking_id}/${payment_id}`;
        let approvePaymentEmailURL = `/email/invoice/${invoice_id}`;
        const data = {
            title: 'Approve Payment',
            message: 'Are you sure you want to approve this payment?',
            confirm: 'Approve',
            cancel: 'Cancel'
        };
        let vm = this ;
       confirm_popup(data, function() {
        $('#popupi').modal('hide');
           let formDataInputs = new FormData();
           formDataInputs.append('ajax', 'ajax');
           formDataInputs.append('key', vm.paymentDetail.payment_key);
            axios.post(approvePaymentURL,formDataInputs,{
                responseType: 'json',
            }).then(function (response) {
                if (response.data.type === 'success') {
                    vm.paymentDetail.is_approved =1;
                    $.notify(response.data.msg, 'success');
                    vm.calculatePricesMethod();
                   send_invoice_popup(approvePaymentEmailURL+'?from_payment_approval=1');
                }else{
                    $.notify(response.data.msg, 'error');
                }
                return
            });
        }, function () {
       })
    },
    unApproveCurrentPayment(object, payment_id = 0, invoice_id = 0,booking_id = 0, merged_invoice_id = 0, index = 0) {
      let unApprovePaymentURL = `/payment/unapprove/${booking_id}/${payment_id}`;
        const data = {
            title: 'Unapprove Payment',
            message: 'Are you sure you want to Unapprove this payment?',
            confirm: 'Unapprove',
            cancel: 'Cancel'
        }
        let vm = this ;

        confirm_popup(data, function() {
            $('#popupi').modal('hide');
            let formDataInputs = new FormData();
            formDataInputs.append('ajax', 'ajax');
            formDataInputs.append('key', vm.paymentDetail.payment_key);
            axios.post(unApprovePaymentURL,formDataInputs,{
                responseType: 'json',
            }).then(function (response) {
                if (response.data.type === 'success') {
                    vm.paymentDetail.is_approved = 0;
                    vm.calculatePricesMethod();
                    $.notify(response.data.msg, 'success');
                }else{
                    $.notify(response.data.msg, 'error');
                }
                $('#confirmation_popup_id').modal('hide');
                return
            });
        }, function () {
        })
    },


      approve_refund( booking_id = 0,id = 0, merged_invoice_id = 0 ) {

          const data = {
              title: 'Approve Refund',
              message: 'Are you sure you want to Approve this Refund?',
              confirm: 'Approve',
              cancel: 'Cancel'
          };
          let vm = this ;
          confirm_popup(data, function() {
              $('#popupi').modal('hide');
              let URL =`/refund/approve/${booking_id}/${id}?booking_id=${booking_id}&id=${id}&merged_invoice_id=${merged_invoice_id}&from_vue_js=1`;
             window.axios.get(URL).then(function (response) {

                  if (response.data.type === 'success') {
                      vm.paymentDetail.is_approved =1;
                      $(`#payment-details-${id}`).modal('hide');
                      vm.calculatePricesMethod();
                      $.notify(response.data.message, 'success');
                  }else{
                      $.notify(response.data.message, 'error');
                  }

              });


          }, function () {
          })
      },


      Unapprove_refund( booking_id = 0,id = 0, merged_invoice_id = 0 ) {
           const data = {
              title: 'Unapprove Refund',
              message: 'Are you sure you want to Unapprove this Refund?',
              confirm: 'Unapprove',
              cancel: 'Cancel'
          };
          let vm = this ;
          confirm_popup(data, function() {
             $('#popupi').modal('hide');
              let URL =`/refund/unapprove/${booking_id}/${id}/${merged_invoice_id}?booking_id=${booking_id}&id=${id}&merged_invoice_id=${merged_invoice_id}&from_vue_js=1`;
              window.axios.get(URL).then(function (response) {

                  if (response.data.type === 'success') {
                      vm.paymentDetail.is_approved = 0;
                      vm.calculatePricesMethod();
                      $.notify(response.data.message, 'success');
                  }else{
                      $.notify(response.data.message, 'error');
                  }

              });


          }, function () {
          })
      },

      addEventListeners() {
        $('#payment-details-' + this.id ).on('hidden.bs.modal', function (e) {
          $('body').css('overflow', 'auto');
        });

          // When a service has been selected from services dropdown
          EventBus.$on('paymentDeclined', (value) => {
              if (value ==this.paymentDetail.id){
                  $('#popupi').modal('hide');
                  this.paymentDetail.is_rejected = 1;
                  this.calculatePricesMethod();
                  return;
              }
          })
          $(this.$refs['modal']).on('hidden.bs.modal', (e) => {
              e.stopPropagation();
          })
          $(this.$refs['modal']).on('shown.bs.modal', (e) => {
              e.stopPropagation();
          })
          // EventBus.$on('paymentRefunded', (value) => {
          //     if (value ==this.paymentDetail.id){
          //         $('#popupi').modal('hide');
          //         this.calculatePricesMethod();
          //         return;
          //     }
          // })
      },




  },
    mounted() {
      this.addEventListeners()
    }
}
</script>

<style scoped>
.modal-header.new-design {
    border-bottom: unset;
}

.has-error .form-control {
    border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    color: #2E4051;
    display: inline;
}

.modal-footer.new-design {
    border-top: unset;
}

.close-icon {
    float: right;
}

.clickable {
    cursor: pointer;
}

.error-label {
    top: 8px;
    position: relative;
}

.btn.new-design {
    border-radius: 8px;
    padding: 12px 16px;
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #2E4051;
}

.btn-primary.new-design {
    background: #FFFFFF !important;
    border-color: #E0E2E5 !important;
}

.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.btn.new-design {
    margin-bottom: unset;
}

.gray-div {
    padding: 12px 16px 12px 16px;
    border-radius: 8px;
    gap: 8px;
    background-color: #F5F5F6;
}

.labels-font {
    font-size: 14px;
    font-weight: 600;
    color: #2E4051;
}

.font-family-Roboto {
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #2E4051;
}

.red-color {
    background-color: #F44336 !important;
}

.status-label{
    color: #FFFFFF!important;
    border-radius: 100px!important;
    padding: 2px 8px 4px 8px !important;
}

.position-status {
    position: relative;
    bottom: 4px;
}
.invoice-popup-container .payment-details-modal-dialog{
    width: 100% !important;
}
@media (max-width: 768px) {
    .gray-div {
        padding: 12px 2px 12px 2px;
    }
    .btn-mobile-width{
        width: 100%;
        padding-bottom: 5px;
    }
    .btn.new-design {
        margin-bottom: 8px;
    }
    .modal-footer .btn+.btn{
        margin-left: 0px;
    }
}
</style>